//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AQSelectionCard from "@/components/Generics/AQSelectionCard/AQSelectionCard.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";

export default {
    components: {
        AQSelectionCard,
        AQButton,
        AQModal,
        AQCard,
        AQInput,
        variablesCard: () => import(/* webpackChunkName: "variablesCard" */ "@/components/Diagrams/variables-card.vue")
    },
    props: {
        elementIndex: { type: Number, default: null },
        value: { type: String, default: "" },
        readonly: { type: Boolean, default: false }
    },
    data() {
        return {
            modalOpened: false,
            instanceName: null,
            showVariables: false,
            wrongPattern: false,
            primary: {
                label: this.$t("generic.done"),
                disabled: true
            }
        };
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData"]),
        computedValue: {
            get() {
                return this.instanceName !== null ? this.instanceName : this.value || "";
            },
            set(v) {
                v = v.replace(/\s+/g, " ");
                this.instanceName = v;
            }
        }
    },
    watch: {
        instanceName: {
            handler(newVal) {
                this.primary.disabled = !newVal || this.wrongPattern;
            }
        }
    },
    methods: {
        actionsDlg($event) {
            if ($event === "primary") {
                if (!this.readonly) {
                    this.$emit("input", this.instanceName);
                    this.hide();
                }
            } else if ($event === "close") {
                this.hide();
            }
        },
        checkInstanceName() {
            const validatePattern = new RegExp(/^[ a-zA-Z0-9_?$!,:;.(){}-]*$/);
            this.wrongPattern = !validatePattern.test(this.instanceName);
        },
        hide() {
            this.modalOpened = false;
            this.showVariables = false;
        },
        onFieldClicked(data) {
            this.computedValue += `${data.field.variable}`;
            this.checkInstanceName();
        }
    }
};
